var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16552 13.1868L6.44743 10.485C6.37147 10.4091 6.3335 10.3114 6.3335 10.192C6.3335 10.0727 6.37147 9.97504 6.44743 9.89908L7.04964 9.31315C7.12559 9.22634 7.22054 9.18294 7.33447 9.18294C7.4484 9.18294 7.54877 9.22634 7.63558 9.31315L9.45849 11.1361L13.3647 7.22982C13.4515 7.14301 13.5519 7.09961 13.6658 7.09961C13.7798 7.09961 13.8747 7.14301 13.9507 7.22982L14.5529 7.81575C14.6288 7.89171 14.6668 7.98936 14.6668 8.10872C14.6668 8.22808 14.6288 8.32573 14.5529 8.40169L9.75146 13.1868C9.6755 13.2736 9.57785 13.317 9.45849 13.317C9.33913 13.317 9.24148 13.2736 9.16552 13.1868Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.0a2df8d34c7f019a81544bffc63bff1f.svg";
export { ForwardRef as ReactComponent };